import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoneyRefund = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 20C10 21.9778 10.5865 23.9112 11.6853 25.5557C12.7841 27.2002 14.3459 28.4819 16.1732 29.2388C18.0004 29.9957 20.0111 30.1937 21.9509 29.8079C23.8907 29.422 25.6725 28.4696 27.0711 27.0711C28.4696 25.6726 29.422 23.8907 29.8079 21.9509C30.1937 20.0111 29.9957 18.0004 29.2388 16.1732C28.4819 14.3459 27.2002 12.7841 25.5557 11.6853C23.9112 10.5865 21.9778 10 20 10C18.1493 9.98662 16.3324 10.4956 14.7581 11.4685C13.1837 12.4415 11.9158 13.8388 11.1 15.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.264 10.57L11.1 15.5L16.03 14.664",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.6 21.868C23.6122 22.2163 23.5442 22.5628 23.4011 22.8807C23.2581 23.1985 23.0439 23.4792 22.775 23.701C22.1077 24.2067 21.3016 24.496 20.465 24.53V26H19.483V24.558C18.4289 24.5576 17.3854 24.3479 16.413 23.941V22.048C16.8944 22.2774 17.3967 22.4599 17.913 22.593C18.4251 22.7379 18.9504 22.8317 19.481 22.873V20.649L19 20.463C18.2475 20.2118 17.5603 19.7964 16.988 19.247C16.5913 18.8005 16.3809 18.2189 16.4 17.622C16.3939 17.2934 16.4643 16.9679 16.6055 16.6711C16.7468 16.3743 16.9551 16.1145 17.214 15.912C17.8735 15.4223 18.6636 15.1397 19.484 15.1V14H20.466V15.069C21.4887 15.1002 22.4963 15.3242 23.436 15.729L22.762 17.407C22.0285 17.1041 21.2528 16.9155 20.462 16.848V18.964C21.1551 19.2074 21.8221 19.5196 22.453 19.896C22.8043 20.1155 23.1009 20.4124 23.32 20.764C23.5113 21.1 23.608 21.4815 23.6 21.868ZM18.558 17.622C18.5551 17.7193 18.5731 17.8161 18.6109 17.9058C18.6487 17.9955 18.7054 18.0761 18.777 18.142C18.9888 18.3188 19.2274 18.4606 19.484 18.562V16.876C18.8673 16.9673 18.5587 17.216 18.558 17.622ZM21.442 21.976C21.4424 21.8782 21.4207 21.7816 21.3784 21.6935C21.3362 21.6053 21.2745 21.5279 21.198 21.467C20.9744 21.2912 20.7282 21.1462 20.466 21.036V22.822C21.116 22.712 21.4413 22.43 21.442 21.976Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgMoneyRefund);
export default ForwardRef;
